import React from 'react';
import * as MdIcons from 'react-icons/md';
import { IconBaseProps } from "react-icons/lib";

type IconProps = {
  iconName: string;
  size?: number;
  color?: string;
} & IconBaseProps;

/**
 * A reusable icon component that renders Material Design icons
 * @param iconName - The name of the icon to render (without the 'Md' prefix)
 * @param size - The size of the icon
 * @param color - The color of the icon
 * @param props - Additional props to pass to the icon
 */
const Icon: React.FC<IconProps> = ({ iconName, size = 24, color = "currentColor", ...props }) => {
  // Construct the full icon name with the Md prefix
  const fullIconName = `Md${iconName}`;
  
  // Get the icon component from the MdIcons object
  const IconComponent = (MdIcons as any)[fullIconName];
  
  if (!IconComponent) {
    console.warn(`Icon "${fullIconName}" not found in Material Design icons.`);
    return null;
  }
  
  return <IconComponent size={size} color={color} {...props} />;
};

export default Icon; 